export const HB_GET_URL_REQUESTED = "HB_GET_URL_REQUESTED";
export const HB_GET_URL_SUCCEEDED = "HB_GET_URL_SUCCEEDED";
export const HB_GET_URL_FAILED = "HB_GET_URL_FAILED";